const TAB_NAV_CONTAINER_KEY = '.tabs';
const TAB_CONTENT_KEY = '.tab-content';
const ACTIVE_CLASS = 'active';

const updateTabComponents = (tab$) => {
  if (typeof Highcharts !== 'undefined') {
    Highcharts.charts.forEach((c) => {
      if (tab$.has(c.container).length) {
        c.reflow();
      }
    });
  }
};

export default class TabComponent {
  constructor() {
    /** @type JQuery<HTMLDivElement> */
    this.navigation = jQuery(TAB_NAV_CONTAINER_KEY);
    /** @type JQuery<HTMLDivElement> */
    this.content = jQuery(TAB_CONTENT_KEY);

    this.activeTabHandler = this.activeTabHandler.bind(this);
  }

  init() {
    if (window.location.hash !== '') {
      const link = `a[href="${window.location.hash}"]`;
      this.activeTabHandler(link);

      this.navigation.find('a').on('click', (event) => {
        event.preventDefault();
        this.activeTabHandler(event.currentTarget);
      });
    } else {
      this.content.children().hide().first().show();
      jQuery('.fund__content .tab-content').hide();
      jQuery('.fund__content .tab-content').first().show();

      this.navigation
        .find('a')
        .on('click', (event) => {
          event.preventDefault();
          this.activeTabHandler(event.currentTarget);
        })
        .filter((index, element) => jQuery(element).closest('li:first-of-type').length)
        .addClass(ACTIVE_CLASS);
    }

    return this;
  }

  /**
   *
   * @param {Event} event
   */
  activeTabHandler(link) {
    const link$ = jQuery(link);

    link$
      .addClass(ACTIVE_CLASS)
      // remove `ACTIVE_CLASS` from siblings
      .closest('li')
      .siblings()
      .children('a')
      .removeClass(ACTIVE_CLASS);

    const tab$ = this.content.children().hide().filter(link$.attr('href')).first().show();

    updateTabComponents(tab$);

    window.history.replaceState(undefined, undefined, link$.attr('href'));
  }
}
